/**
 * Created by renjie.huang on 2015/6/5.
 */
var reqwest = require('reqwest');
var ucloud = require('./url');
var conf = require('../config/config');
var cookie = require('../common/cookie');
var time = require('./time');
var { getChannelKey } = require('./channel');
var action = require('./action');

var _ = require('_');
var request = function(action,data){
    var self = this;
    self.url = conf.url;
    self.data = data || {};
    self.callback = {
        success:function(){}
        ,fail:function(){}
        ,always:function(){}
    };
    init.apply(self,arguments);
};
function init(){
    var self = this;
    var arg = arguments;
    var CSRF = cookie.getCSRFToken();
    var UCSRF = cookie.getUCSRFToken();
    var channelKey = getChannelKey();

    var params = {
        url : self.buildUrl.apply(self,arg)
        , type :  self.buildType.apply(self,arg)
        , timeout: 90000
        , method : self.buildMethod.apply(self,arg)
        , crossOrigin : true
        , withCredentials : true
        , data : self.buildParams.apply(self,arg),
        headers : self.buildHeaders.apply(self,arg)
    };
    
    if(CSRF){
        params.headers['CSRF-Token']= CSRF;
    }
    if(UCSRF){
        params.headers['U-CSRF-Token']= UCSRF;
    }
    if(channelKey){
        params.headers['channel-key']= channelKey;
        if(params.data.Action === action.register.registerAccount.action){
            params.headers['channel-invitation-code'] = params.data.InvitationCode;
        }
    }

    var start = Date.now();
    var r = reqwest(params).then(function(datas){
        if((arg[0]||{})['static']){
            self.callback.success(datas);
            return;
        }
        var code = datas['RetCode'];
        var i18n = null;
        try {
            i18n = r.request.getResponseHeader("x-message-i18n");
        } catch(e) {
            console.error(e);
        }

        if(datas && code == 0){
            var result = self.getResponse(arg[0],datas) || [];
            self.callback.success(result);
        }else{
            if(i18n){
                datas['I18N-Message'] = datas['Message'];
            }
            self.callback.fail(datas);
        }
    }).fail(function(e){
        var status = e.status;
        var timeout = e.timeout;
        var start = Date.now();
        var datas  = status !==0 ? {RetCode: 'status_'+ status,Message: 'Network exception, please try again！[' + status + ']'}: Date.now() - start >= timeout? {RetCode: 'status_100', Message: 'timeout'} : {RetCode: 'status_200',Message: 'Network exception, please try again！'};
        self.callback.fail(datas);
    }).always(function(resp){
        self.callback.always(resp);
    });
    return self;
}
request.prototype = {
    buildParams: function(){
        var action = arguments[0] || {};
        var data = arguments[1] || {};
        var headers = this.buildHeaders.apply(this, arguments);

        if(action['static']){
            return '';
        }
        var params = {
            _timestamp: time.date('Y-m-d##H:m:s', Date.now() / 1000) + '##' + _.uniqueId()
        };
        if(action['action']){
            params['Action'] = action['action'];
        }
        var mergedParams = _.extend({}, params, data);
        // 根据 Content-Type 返回不同格式
        if (headers['Content-Type'] && headers['Content-Type'].indexOf('application/json') !== -1) {
            return JSON.stringify(mergedParams);
        }
        return mergedParams;
    },
    getResponse : function(){
        var action = arguments[0] || {};
        var data = arguments[1] || {};
        return data ? (action['collection'] ? data[action['collection']] : data ) : null
    },
    buildUrl:function(){
        var arg = arguments[0] || {};
        if(arg['url']){
            return  arg['url'];
        }
        return arg['static'] ? arg['action'] + '.json': conf.url;
    },
    buildType:function(){
        var arg = arguments[0] || {};
        if(arg['type']){
            return  arg['type'];
        }
        return arg['type'] || 'json';
    },
    buildMethod:function(){
        var arg = arguments[0] || {};
        if(arg['method']){
            return  arg['method'];
        }
        return arg['type'] === 'jsonp' ? 'GET' : (arg['method'] || 'post');
    },
    buildHeaders:function(){
        var arg = arguments[0] || {};
        if(arg['headers']){
            return  arg['headers'];
        }
        return {'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'};
    },
    success:function(fn){
        var self = this;
        self.callback.success = fn;
        return self;
    },
    fail:function(fn){
        var self = this;
        self.callback.fail = fn;
        return self;
    },
    always:function(fn){
        var self = this;
        self.callback.always = fn;
        return self;
    }
};
module.exports = function(action,data){
    return new request(action,data);
};


// WEBPACK FOOTER //
// ./src/common/request.js